var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluscirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.3359 -75.1582 79.8575 79.8086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z M50.0488-20.5078L50.0488-50.0488C50.0488-52.3438 48.4863-53.9551 46.1914-53.9551C43.9453-53.9551 42.4805-52.3438 42.4805-50.0488L42.4805-20.5078C42.4805-18.2617 43.9453-16.6504 46.1914-16.6504C48.4863-16.6504 50.0488-18.2617 50.0488-20.5078ZM31.4941-31.4941L61.0352-31.4941C63.2812-31.4941 64.8926-33.0078 64.8926-35.2539C64.8926-37.5488 63.2812-39.1113 61.0352-39.1113L31.4941-39.1113C29.1992-39.1113 27.6367-37.5488 27.6367-35.2539C27.6367-33.0078 29.1992-31.4941 31.4941-31.4941Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscirclefill);
export default __webpack_public_path__ + "static/media/plus.circle.fill.5e1c1cb13ca466aef920123e70e86399.svg";
export { ForwardRef as ReactComponent };